// src/components/common/BottomCompletionBar.jsx (JS 버전)
import { useEffect, useRef, useState } from "react";
import { RealLoadingBar } from "../../utils/loadingBar";

export default function BottomCompletionBar({
    offsetBottom = "calc(4rem + env(safe-area-inset-bottom))",
    height = 2,
    duration = 400,
    minElapsed = 0,
}) {
    const [show, setShow] = useState(false);
    const [w, setW] = useState(0);
    const prev = useRef({ visible: false, percent: 0 });
    const startedAt = useRef(null);
    const hideTimer = useRef(null);

    useEffect(() => {
        const unsubscribe = RealLoadingBar.subscribe((snap) => {
            const p = prev.current;

            // 로딩 시작 시점 기록
            if (!p.visible && snap.visible) {
                startedAt.current = Date.now();
            }

            // 완료 순간 감지
            if (snap.visible && snap.percent >= 100 && p.percent < 100) {
                const elapsed = startedAt.current ? Date.now() - startedAt.current : 0;
                if (elapsed >= minElapsed) {
                    setShow(true);
                    setW(0);
                    // 다음 프레임에 0 -> 100 애니메이션
                    requestAnimationFrame(() => setW(100));
                    if (hideTimer.current) clearTimeout(hideTimer.current);
                    hideTimer.current = setTimeout(() => setShow(false), duration + 150);
                }
            }

            // 상태 업데이트 & 초기화
            prev.current = snap;
            if (!snap.visible && snap.percent === 0) {
                startedAt.current = null;
            }
        });


        return () => {
            unsubscribe();
            if (hideTimer.current) clearTimeout(hideTimer.current);
        };
    }, [duration, minElapsed]);

    if (!show) return null;

    return (
        <div className="fixed inset-x-0 z-[9999] pointer-events-none" style={{ bottom: offsetBottom }}>
            <div style={{ height, background: "transparent" }} />
            <div
                className="transition-[width] ease-out"
                style={{
                    height,
                    width: `${w}%`,
                    transitionDuration: `${duration}ms`,
                    backgroundColor: "#4A8AFF",
                }}
            />
        </div>
    );
}
